import { render, staticRenderFns } from "./CloseTicket.vue?vue&type=template&id=4f1e1728&"
import script from "./CloseTicket.vue?vue&type=script&lang=js&"
export * from "./CloseTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports